const dev = {
  API_URL: "https://devapi.masternaukri.com",
  TENANT_KEY: "044a030b-a0cd-412b-8539-aa3a80a8ecd5",
  MEDIAPATH: "https://kid-ex.com",
  IMGPATH: "https://kid-ex.com/skin/images/",
}

export const config = process.env.NODE_ENV === "development" ? dev : window._env_.config;

export default { config };